import React from 'react';

export const Logo = ({height = 27, width = 26, fill = "var(--urtentic-sdk-primary, #255CFF)", logoUrl}) => {

    if (logoUrl) {
        // Stands in for the whole icon+"URTENTIC" wordmark unit (see Header.jsx),
        // so it needs room to read as a real logo rather than the tiny square
        // icon slot — fixed height, auto width so a wide wordmark-style image
        // isn't squashed into a 26px-wide box.
        return <img src={logoUrl} alt="Logo" style={{height: 32, width: "auto"}}/>;
    }

    return (
        <svg width={width} height={height} viewBox="0 0 30 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.784 11.3867C15.5713 11.5858 15.2871 11.6971 14.9912 11.6971C14.6953 11.6971 14.4111 11.5858 14.1984 11.3867C12.2507 9.55204 9.64063 7.50255 10.9135 4.52711C11.6017 2.91831 13.2538 1.88885 14.9912 1.88885C16.7286 1.88885 18.3807 2.91831 19.0689 4.52711C20.3402 7.49883 17.7365 9.55836 15.784 11.3867Z"
                fill={fill} stroke="var(--urtentic-sdk-primary, #255CFF)" strokeWidth="0.781503"/>
            <path
                d="M16.7049 6.30235C16.7049 7.25032 15.9365 8.01879 14.9885 8.01879C14.0405 8.01879 13.2721 7.25032 13.2721 6.30235C13.2721 5.35438 14.0405 4.58591 14.9885 4.58591C15.9365 4.58591 16.7049 5.35438 16.7049 6.30235Z"
                fill="white"/>
            <path
                d="M5.24615 8.13278C8.14356 8.13278 10.4924 10.4816 10.4924 13.379V24.1893C10.4924 25.5038 10.8247 26.5501 11.4894 27.3281C12.1857 28.0793 13.2935 28.4549 14.8128 28.4549C16.3321 28.4549 17.4557 28.0793 18.1837 27.3281C18.9116 26.5501 19.2756 25.5038 19.2756 24.1893V13.379C19.2756 10.4816 21.6245 8.13278 24.5219 8.13278C27.4193 8.13278 29.7681 10.4816 29.7681 13.379V24.1893C29.7681 26.8989 29.1034 29.2195 27.774 31.1511C26.4447 33.0559 24.6247 34.4912 22.3142 35.457C20.0036 36.4228 17.424 36.9057 14.5754 36.9057C11.7268 36.9057 9.19467 36.4228 6.97907 35.457C4.79512 34.4912 3.08594 33.0559 1.85154 31.1511C0.617134 29.2463 -6.86646e-05 26.9257 -6.86646e-05 24.1893V13.379C-6.86646e-05 10.4816 2.34874 8.13278 5.24615 8.13278Z"
                fill={fill}/>
        </svg>


    )
};